export default {
  background: {
    default: '#fafaf9',
    dark: '#21222C',
    surface: '#f7f9f9',
  },
  primary: {
    main: '#19b5d2', // Cyan/teal from Figma design
    light: '#E5EEFF',
    dark: '#1990a5',
    cyan50: '#e0f7fa',
    cyan100: '#b2ebf2',
  },
  secondary: {
    main: '#4785FF', // Original primary, kept as secondary
  },
  text: {
    primary: '#111827',
    secondary: '#000000',
    high: '#263238',
    regular: '#607d8b',
    low: '#b0bec5',
  },
  button: {
    gradient: 'linear-gradient(180deg, rgba(50,52,75,1) 0%, rgba(33,34,44,1) 100%)',
  },
  divider: '#626F888F',
  border: {
    regular: '#cfd8dc',
  },
  card: {
    background: '#ffffff',
  },
  blueGrey: {
    50: '#eceff1',
    200: '#b0bec5',
    300: '#90a4ae',
    500: '#607d8b',
    600: '#546e7a',
    700: '#455a64',
    800: '#37474f',
    900: '#263238',
  },
  yellow: {
    700: '#fbc02d',
  },
};
